package com.zq.webproject.utils

import androidx.compose.material3.SnackbarDuration
import androidx.compose.material3.SnackbarHostState
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.launch

/**
 * Toast/Snackbar管理器
 * 负责全局的提示信息显示
 * 类似TokenManager的单例模式
 */
object ToastManager {
    private var snackbarHostState: SnackbarHostState? = null
    private var coroutineScope: CoroutineScope? = null

    /**
     * 初始化ToastManager
     * 在应用启动时或主界面初始化时调用
     */
    fun init(hostState: SnackbarHostState, scope: CoroutineScope) {
        println("ToastManager - 初始化")
        snackbarHostState = hostState
        coroutineScope = scope
    }

    /**
     * 显示成功提示
     */
    fun showSuccess(message: String) {
        println("ToastManager - 显示成功提示: $message")
        show(message, SnackbarDuration.Short)
    }

    /**
     * 显示错误提示
     */
    fun showError(message: String) {
        println("ToastManager - 显示错误提示: $message")
        show(message, SnackbarDuration.Long)
    }

    /**
     * 显示普通提示
     */
    fun showInfo(message: String) {
        println("ToastManager - 显示普通提示: $message")
        show(message, SnackbarDuration.Short)
    }

    /**
     * 显示提示（内部方法）
     */
    private fun show(message: String, duration: SnackbarDuration) {
        if (snackbarHostState == null || coroutineScope == null) {
            println("ToastManager - 错误：ToastManager未初始化，无法显示提示")
            return
        }

        coroutineScope?.launch {
            try {
                snackbarHostState?.showSnackbar(
                    message = message,
                    duration = duration
                )
                println("ToastManager - 提示显示完成")
            } catch (e: Exception) {
                println("ToastManager - 显示提示失败: ${e.message}")
            }
        }
    }
}